import { render, staticRenderFns } from "./VolverButton.vue?vue&type=template&id=43a77802&scoped=true&"
import script from "./VolverButton.vue?vue&type=script&lang=ts&"
export * from "./VolverButton.vue?vue&type=script&lang=ts&"
import style0 from "./VolverButton.vue?vue&type=style&index=0&id=43a77802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a77802",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('43a77802', component.options)
    } else {
      api.reload('43a77802', component.options)
    }
    module.hot.accept("./VolverButton.vue?vue&type=template&id=43a77802&scoped=true&", function () {
      api.rerender('43a77802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Modal/VolverButton.vue"
export default component.exports